module.exports = __webpack_public_path__ + "img/IMG_2142.afda5c9c.jpg";